import classNames from 'classnames';
import { useEffect, useState } from 'react';
import styles from './Picture.module.scss';

/**
 * Picture
 *
 * @return {JSX.Element}
 */
const Picture = ({ className, onLoad, src, alt, ...rest }) => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  useEffect(() => {
    const image = new Image();
    image.onload = () => setIsImageLoading(false);
    image.onerror = () => setIsImageLoading(false);
    image.src = src;

    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, [src]);

  return (
    <img
      className={classNames(
        styles.Picture,
        isImageLoading && styles.Picture__loading,
        className,
        `${Picture.displayName}`
      )}
      {...rest}
      src={src}
      alt={alt || ''}
    />
  );
};

Picture.displayName = 'Picture';

export default Picture;
